import { useAchievementTypes, useReduxState } from 'hooks';
import { useFormState } from 'informed';
import { CopyButtonText } from 'components/common';
import { FormGroup, Text } from 'components/common/form';
import { Icon } from 'components/common/icons';

const AchievementSettingsDetailsExternal = () => {
  const formState = useFormState();

  const {
    messages,
    pageState: { achievement }
  } = useReduxState();

  const { hasCompletionDetails } = useAchievementTypes({
    type: achievement?.type
  });

  return !hasCompletionDetails ? null : (
    <>
      <FormGroup
        htmlFor="external-provider"
        label={messages.achievementExternalProvider}
        labelHelpTextServerConfigKey="achievementProvider"
      >
        <Text field="externalProvider" id="external-provider" />
      </FormGroup>

      <div className="link-container">
        <FormGroup
          htmlFor="external-url"
          label={
            <div className="link-label">
              <div className="link-label-text">
                {messages.achievementExternalUrl}

                <div
                  aria-label={messages.achievementExternalUrlTooltip}
                  data-tooltip={messages.achievementExternalUrlTooltip}
                >
                  <Icon icon="question-circle" style={{ fontSize: '1.3rem' }} />
                </div>
              </div>
              <div className="link-label-copy">
                <CopyButtonText
                  successText={messages.commonCopied}
                  text={messages.commonCopyLink}
                  value={formState.values.externalUrl as string}
                />
              </div>
            </div>
          }
          labelHelpTextServerConfigKey="achievementExternalUrl"
        >
          <Text field="externalUrl" id="external-url" />
        </FormGroup>

        <style jsx>{`
          .link-container {
            margin-top: 15px;
          }
          .link-container :global(.form-group .label) {
            display: block;
            max-width: 540px;
          }
          .link-label {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
          }
          .link-label-text {
            align-items: center;
            display: flex;
            flex-direction: row;
            gap: 5px;
          }
          .link-label-copy {
            flex: 0 1 auto;
          }
        `}</style>
      </div>
    </>
  );
};

export default AchievementSettingsDetailsExternal;
